import EmbeddedLayout from '../../layouts/EmbeddedLayout';
import FlowFooter from '../../components/FlowFooter';
import WaitingContent from '../shared/WaitingContent';
import { useTranslation } from '../../i18n/i18n';

type Props = {
  onCancel: () => void;
  onBack?: () => void;
};

export default function EmbeddedWaitingPage({ onCancel, onBack }: Props) {
  const { t } = useTranslation();

  const secondaryLabel = onBack ? t('abort.goBack') : t('agentStart.cancel');
  const onSecondary = onBack ?? onCancel;

  return (
    <EmbeddedLayout
      footer={
        <FlowFooter secondaryLabel={secondaryLabel} onSecondary={onSecondary} />
      }
    >
      <WaitingContent />
    </EmbeddedLayout>
  );
}
